import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateRangeValidator(startDateControlName: string, endDateControlName: string) {
  return function (formGroup: AbstractControl): ValidationErrors | null {
    const startDateControl = formGroup.get(startDateControlName);
    const endDateControl = formGroup.get(endDateControlName);

    if (!startDateControl || !endDateControl) {
      return null;
    }

    const startDateValue = startDateControl.value;
    const endDateValue = endDateControl.value;

    if (!startDateValue || !endDateValue) {
      if (endDateControl.hasError('dateRangeInvalid')) {
        const errors = { ...endDateControl.errors };
        delete errors.dateRangeInvalid;
        endDateControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
      }
      return null;
    }

    const startDate = new Date(startDateValue);
    const endDate = new Date(endDateValue);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return null;
    }

    if (startDate > endDate) {
      const endDateErrors = { ...endDateControl.errors };
      endDateErrors.dateRangeInvalid = {
        startDate: startDateValue,
        endDate: endDateValue
      };
      endDateControl.setErrors(endDateErrors);
    } else {
      if (endDateControl.hasError('dateRangeInvalid')) {
        const errors = { ...endDateControl.errors };
        delete errors.dateRangeInvalid;
        endDateControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
      }
    }

    return null;
  };
}
